<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("Order.Fields.redeliverError") }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-divider></v-divider>

      <!-- 表格 -->
      <v-data-table 
        :headers="headers"
        :items="Items"
        :loading="loading"
        multi-sort
        class="elevation-0 px-6"
        fixed-header
        height="340px"
      >
        <template v-slot:item.price="{ item }">
          <span>
            {{ $t("Global.money") }}{{ item.confirm_price }}
          </span>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="dialog = false"
          class="elevation-1"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";

export default {
  name: "DialogShop",

  props: {
    value: Boolean,
    Items: Array,
    isActivity: Boolean,
  },
  computed: {
    headers() {
      return [
        {
          text: i18n.t("Order.DetailFields.category"),
          align: "start",
          sortable: false,
          value: "category_name",
        },
        {
          text: i18n.t("Order.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("Order.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("Order.DetailFields.unit"),
          align: "start",
          sortable: false,
          value: "unit",
        },
        {
          text: i18n.t("Order.DetailFields.confirm_num"),
          align: "start",
          sortable: false,
          value: "confirm_num",
        },
        {
          text: i18n.t("Order.DetailFields.price"),
          align: "start",
          sortable: false,
          value: "price",
        },
      ];
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>
